var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white","color":"black"}},[_c('mt-header',{attrs:{"title":"咨詢費通知"}}),_vm._v(" "),_c('div',{staticStyle:{"padding":"20px"}},[_c('span',{staticStyle:{"font-size":"20px"}},[_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.dateCode))]),_vm._v("期的咨詢費已經發放, 請登入系統查看咨詢費詳細!")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b4b7d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wechat/CommNote.vue
// module id = m3Vz
// module chunks = 85